(function () {
  const loader = document.querySelector('[data-ilu-page-loader]');
  if (!loader) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fadeOutDelay = 0;
  const removeDelay = reduceMotion ? 0 : 220;
  let hideStarted = false;

  function hideLoader() {
    if (hideStarted) return;
    hideStarted = true;

    window.setTimeout(function () {
      loader.classList.add('ilu-page-loader--hidden');
      window.setTimeout(function () {
        loader.remove();
      }, removeDelay);
    }, fadeOutDelay);
  }

  function showLoaderForNavigation(url) {
    loader.classList.remove('ilu-page-loader--hidden');
    loader.classList.add('ilu-page-loader--entering');
    window.setTimeout(function () {
      window.location.href = url;
    }, reduceMotion ? 0 : 280);
  }

  function isSameStoreLink(link) {
    if (!link || !link.href) return false;
    if (link.target && link.target !== '_self') return false;
    if (link.hasAttribute('download')) return false;

    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin) return false;
    if (url.pathname === window.location.pathname && url.hash) return false;
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return false;

    return true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideLoader, { once: true });
  } else {
    hideLoader();
  }
  window.setTimeout(hideLoader, 1000);

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      loader.classList.add('ilu-page-loader--hidden');
    }
  });

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const link = event.target.closest('a');
    if (!isSameStoreLink(link)) return;
    if (!loader.isConnected) return;

    event.preventDefault();
    showLoaderForNavigation(link.href);
  });

  function enhanceContactForm() {
    if (!/\/pages\/contact\/?$/.test(window.location.pathname)) return;

    const form = document.querySelector('form.contact-form__form input[name="contact[email]"]')?.closest('form');
    if (!form) return;

    form.id = 'contact_Us';
    form.action = '/contact#contact_Us';

    let sourceInput = form.querySelector('input[name="contact[Source Page]"]');
    if (!sourceInput) {
      sourceInput = document.createElement('input');
      sourceInput.type = 'hidden';
      sourceInput.name = 'contact[Source Page]';
      form.insertBefore(sourceInput, form.firstChild);
    }
    sourceInput.value = 'contact_Us';

    let idInput = form.querySelector('input[name="contact[id]"]');
    if (!idInput) {
      idInput = document.createElement('input');
      idInput.type = 'hidden';
      idInput.name = 'contact[id]';
      form.insertBefore(idInput, form.firstChild);
    }
    idInput.value = 'contact_Us';

    function showContactNotice(message, state) {
      let notice = document.getElementById('contact_Us-success');
      if (!notice) {
        notice = document.createElement('div');
        notice.id = 'contact_Us-success';
        notice.className = 'contact-form__success';
        notice.tabIndex = -1;
        notice.setAttribute('role', state === 'sending' ? 'status' : 'status');
        notice.setAttribute('aria-live', 'polite');
        form.insertBefore(notice, form.firstChild);
      }
      notice.textContent = message;
      notice.style.display = 'flex';
      notice.style.alignItems = 'center';
      notice.style.gap = '0.5rem';
      notice.style.padding = '1rem 1.25rem';
      notice.style.borderRadius = '8px';
      notice.style.lineHeight = '1.4';
      notice.style.color = state === 'sending' ? '#1f2937' : '#14532d';
      notice.style.background = state === 'sending' ? '#f8fafc' : '#f0fdf4';
      notice.style.border = state === 'sending' ? '1px solid #cbd5e1' : '1px solid #86efac';
      notice.scrollIntoView({ block: 'center' });
      notice.focus({ preventScroll: true });
    }

    if (window.sessionStorage.getItem('iluContactSubmitted') === '1') {
      window.sessionStorage.removeItem('iluContactSubmitted');
      showContactNotice('Message sent. We will reply within 1 to 3 business days.', 'success');
    }

    form.addEventListener('submit', function () {
      form.id = 'contact_Us';
      form.action = '/contact#contact_Us';
      idInput.value = 'contact_Us';
      sourceInput.value = 'contact_Us';
      window.sessionStorage.setItem('iluContactSubmitted', '1');
      showContactNotice('Sending your message...', 'sending');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceContactForm);
  } else {
    enhanceContactForm();
  }
})();
